import React from 'react'
import HeaderComponent from '../WebSite/Header/HeaderComponent'
import FooterComponent from '../WebSite/Footer/FooterComponent'

const Layout = ({children}) => {
  return (
    <>
    <HeaderComponent/>
    {children}
    <FooterComponent/>
    </>
  )
}

export default Layout